import {
  collection,
  addDoc,
  setDoc,
  getDoc,
  doc,
  serverTimestamp,
  arrayUnion,
  arrayRemove,
  updateDoc,
} from "firebase/firestore";
import { db, auth } from "../FireStore";
import { updateUser } from "./user";

export async function createCompany(companyData) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("No authenticated user found.");
  }
  const companyId = companyData.companyId || user.uid; // Use user UID as the document ID
  const companyRef = doc(db, "companies", companyId);

  await setDoc(companyRef, {
    ...companyData,
    id: companyId,
    createdAt: serverTimestamp(),
  });

  // Optionally update the user document with the company ID
  // await updateUser(user.uid, { companyIdsToAdd: [companyId] });

  return `Company with ID ${companyId} created successfully.`;
}

export async function getCompanyById(companyId) {
  const companyDocRef = doc(db, "companies", companyId);
  const companyDocSnapshot = await getDoc(companyDocRef);

  if (companyDocSnapshot.exists()) {
    const companyData = companyDocSnapshot.data();
    return companyData;
  } else {
    console.log("No company found with the provided ID.");
    return null;
  }
}

export async function getCustomerData(customerId) {

  try {
    const customerDocRef = doc(db, "customers", customerId);
    const customerDocSnapshot = await getDoc(customerDocRef);
  
  
    if (customerDocSnapshot.exists()) {
      const customerData = customerDocSnapshot.data();
      return customerData;
    } else {
      console.log("No customer found with the provided ID.");
      return null;
    }
  } catch (error) {
    throw new Error(`Error fetching customer data: ${error.message}`);
}
} 

// updateCompanyById
export async function updateCompanyById(companyId, updatedData) {
  const companyDocRef = doc(db, "companies", companyId);

  try {
    await updateDoc(companyDocRef, updatedData);
    console.log("Company updated successfully.");
  } catch (error) {
    console.error("Error updating company:", error);
  }
}
